import { gql } from "@apollo/client";

export const RECHAZAR_CAPA = gql` 
    mutation rechazarCapa($input: EditEstadoGestionCapaInput!){
        rechazarCapa(input: $input) {
            idGestionCapa
        }
    }
`;